// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1l_DY","colBig":"styles_colBig__1Ai4V","colSmall":"styles_colSmall__34vMg"};